import { IInvoice, IPaymentType } from "@nju/data-access-portal-payment";
import { formatPrice as globalFormatPrice } from "@nju/utils";

/**
  nota obciążeniowa -> NOTE + STANDARD
  nota uznaniowa -> NOTE + CORRECTIVE
  faktura -> INVOICE + STANDARD
  faktura korekta -> INVOICE + CORRECTIVE
 */
export function getName(
  documentType: IInvoice["documentType"] = "INVOICE",
  invoiceType: IInvoice["invoiceType"],
) {
  if (documentType === "NOTE" && invoiceType === "STANDARD") {
    return "nota obciążeniowa";
  }
  if (documentType === "NOTE" && invoiceType === "CORRECTIVE") {
    return "nota uznaniowa";
  }
  if (documentType === "INVOICE" && invoiceType === "STANDARD") {
    return "faktura";
  }
  if (documentType === "INVOICE" && invoiceType === "CORRECTIVE") {
    return "faktura korekta";
  }

  return `${documentType} ${invoiceType}`;
}

export function formatPrice(amount: number, type: IPaymentType = "PAYMENT") {
  const prefix = type === "REFUND" ? "-" : "";
  return prefix + `${globalFormatPrice(+amount)} zł`;
}

export function getPaymentStatus(status: string) {
  if (status === "PAID") {
    return "opłacona";
  }
  if (status === "NOT_PAID") {
    return "nieopłacona";
  }
  return;
}

export function getPaymentColor(status: string) {
  if (status === "PAID") {
    return "inherit";
  }
  if (status === "NOT_PAID") {
    return "accent";
  }
  return;
}
